/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { loadUniversalTrackerModal } from '../../actions/universalTrackerModal';
import UniversalTrackerValue from '../../model/UniversalTrackerValue';

class UniversalTrackerActionContainer extends PureComponent {

  loadUTrModal = (e, utrv) => {
    e.preventDefault();
    this.props.loadUniversalTrackerModal(utrv.getUniversalTrackerId(), 'utr', utrv.getId());
  };

  render() {
    const { universalTrackerValues } = this.props;

    const sortFunction = (a, b) => a.effectiveDate > b.effectiveDate ? 1 : a.effectiveDate < b.effectiveDate ? -1 : 0;
    const utrvs = universalTrackerValues.sort(sortFunction).map((utrv) => new UniversalTrackerValue(utrv));
    const isEscalated = utrvs.some((utrv) => utrv.isEscalated());
    const escalatedClassName = isEscalated ? 'statusUrgent' : '';

    return (
      <div className={'actionContainer p-3 ' + escalatedClassName}>
        <div className='row'>
          <div className='col'>
            <div className='taskSubtitle'>
              {this.getInitiativeName()}
            </div>
            <div className='taskTitle'>
              <strong>{this.getUniversalTrackerName()}</strong>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col offset-lg-5 col-lg-7'>
            {this.renderActionList(utrvs)}
          </div>
        </div>
      </div>
    )
  }

  renderActionList(utrvs) {
    return <div className='actionTableContainer mt-2 mr-2'>
      <div className='row actionTableHeader'>
        <div className='offset-1 col-8'>
        </div>
        <div className='col-3 text-right'>
          <strong>Due Date</strong>
        </div>
      </div>
      {utrvs.map((utrv) => this.renderActionRow(utrv))}
    </div>;
  }

  renderActionRow(utrv) {
    const { currentUserState } = this.props;
    const currentUserId = currentUserState && currentUserState.data._id;

    const isVerifier = utrv.userHasVerifierAction(currentUserId);
    const isRejected = utrv.isRejected();
    const isEscalated = utrv.isEscalated();
    const isOverdue = utrv.isOverdue();

    return <div className={'row actionTableRow'} key={utrv.getId()}
      onClick={(e) => this.loadUTrModal(e, utrv)} >
      <div className='col-1 text-center'>
        {this.renderActionButton(isRejected, isOverdue, isVerifier)}
      </div>
      <div className='col-8'>
        {this.renderActionText(utrv.getType(), isRejected, isOverdue, isVerifier)}
        {isEscalated && <span className='badge bg-danger ml-1'>URGENT</span>}
      </div>
      <div className='col-3 text-right text-nowrap' >
        {this.OverdueIcon(isOverdue)}
        {utrv.getDate()}
      </div>
    </div >
  }

  OverdueIcon(isOverdue) {
    if (!isOverdue) {
      return '';
    }

    return <i
      title={'Overdue'}
      style={{color: 'orange', marginRight: '3px'}}
      className='fa fa-exclamation-triangle'/>;
  }

  getTypeString(type) {
    switch (type) {
      case 'target':
        return 'Target Value';
      case 'baseline':
        return 'Baseline Value';
      case 'actual':
        return 'Current Value';
      default:
        return 'Value';
    }
  }

  renderActionText(type, isRejected, isOverdue, isVerifier) {
    const typeStr = <strong>{this.getTypeString(type)}</strong>;
    if (isRejected) {
      return <span className='text-danger'>{typeStr} requires update <span className='badge bg-danger'>REJECTED</span></span>;
    }
    if (isVerifier) {
      return <span className='text-success'>Verification required for {typeStr}</span>;
    }

    return <span>{typeStr} required</span>;
  }

  renderActionButton(isRejected, isOverdue, isVerifier) {
    if (isRejected) {
      return <span className={'material-icons actionButton text-negative'} >undo</span>
    }
    if (isVerifier) {
      return <span className={'material-icons actionButton text-success'} >redo</span>
    }

    return <i style={{ fontSize: '0.5rem' }} className='fas fa-circle text-primary' />;
  }

  getUniversalTrackerName() {
    const { universalTracker, universalTrackerId } = this.props.universalTrackerValues[0];
    return universalTracker ? universalTracker.name : universalTrackerId;
  }

  getInitiativeName() {
    const { initiativeId, initiatives } = this.props.universalTrackerValues[0];
    const initiative = initiatives && initiatives.find(i => i._id === initiativeId);
    return initiative ? initiative.name : initiativeId;
  }
}

const mapStateToProps = (state) => ({
  currentUserState: state.currentUser,
});

const mapDispatchToProps = {
  loadUniversalTrackerModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(UniversalTrackerActionContainer);
